import * as React from 'react';
import Card from '@mui/material/Card';
import { CardMedia } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import Modal from '@mui/material/Modal';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import StickyHeader from '../components/stickyHeader';
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useParams } from 'react-router-dom';
import { fetchProductList, getProductFromProductList } from '../Platforms';
import { useState } from 'react';
import { getFilterById } from '../Database/Vehicles/vehicleList';
import { Box } from '@mui/system';






function Checkout(props) {

    // Represents the cart state
    let cart = [];

    // Dummy Line item
    let cartObject = JSON.parse('{"selectedVehicleFilter":{"id":1678,"make":"HOLDEN","model":"COMMODORE","series":"VS","engine":"3.8L Ecotec LN3, L36 OHV 12v MPFI V6","variant":"SERIES 1 2dr Utility 4sp Auto RWD"},"selectedProduct":{"id":3,"name":"Lite Series","price":1000,"image":["/product_images/gj/lite.jpg","/product_images/gj/tailshaft_2.jpg"],"description":"Reduce tailshaft weight - for serious racing applications","productDescription":"Product Description text","stockStatus":1,"configurableOptions":[{"id":1,"name":"Universal Joint Bolt ons","image":"/product_images/gj/unis.jpg","stockStatus":1,"options":[{"id":1,"name":"1320 Downgrade","price":300,"stockStatus":0},{"id":2,"name":"1340 Upgrade","price":300,"stockStatus":1},{"id":3,"name":"1350 Upgrade","price":500,"stockStatus":1}]},{"id":2,"name":"Yoke Style","image":"/product_images/gj/yoke.jpg","stockStatus":1,"options":[{"id":1,"name":"Cast","price":0,"stockStatus":1},{"id":2,"name":"Billet","price":100,"stockStatus":1},{"id":3,"name":"Forged","price":500,"stockStatus":1}]}],"filters":{"make":{"value":["HOLDEN"]},"model":{"value":["COMMODORE"]},"series":{"value":["VS"]},"engine":{"value":[""]},"variant":{"value":[""]}}},"selectedProductPrice":1000,"selectedProductLink":"http://localhost:3000/store/details/3/1678","selectedConfig":[{"config":{"id":1,"name":"Universal Joint Bolt ons","image":"/product_images/gj/unis.jpg","stockStatus":1,"options":[{"id":1,"name":"1320 Downgrade","price":300,"stockStatus":0},{"id":2,"name":"1340 Upgrade","price":300,"stockStatus":1},{"id":3,"name":"1350 Upgrade","price":500,"stockStatus":1}]},"configOption":{"id":2,"name":"1340 Upgrade","price":300,"stockStatus":1}},{"config":{"id":2,"name":"Yoke Style","image":"/product_images/gj/yoke.jpg","stockStatus":1,"options":[{"id":1,"name":"Cast","price":0,"stockStatus":1},{"id":2,"name":"Billet","price":100,"stockStatus":1},{"id":3,"name":"Forged","price":500,"stockStatus":1}]},"configOption":{"id":2,"name":"Billet","price":100,"stockStatus":1}}]}');

    // Push a bunch of dummy valuies into the cart
    for (let i = 0; i < 5; i++) {
        cart.push(cartObject);
    }

    return <Stack>
        <StickyHeader label="Checkout" />
    </Stack>

}

export default Checkout;